import { TCurrentRegion } from '../../types/currentRegion';
import { IApplicationState } from '../../types/redux';

export const selectCurrentRegion = (state: IApplicationState): TCurrentRegion => state.currentRegion;
